import { ScaleMode } from '../Enums';

export default class ImagePlayer {
    constructor(testElement) {
        this.signal = null;
        this.testElement = testElement;
        this.startLoading = [];
        this.endLoading = [];
        this.isStarted = false;
        this.isSkipped = false;
        this.displayTimeout = null;
        this.position = null;
        this.updatePositionTimeout = null;
        this.stateChangedCallback = null;
        this.isPreloaded = false;
        this.isActive = false;
        this.imageElement = document.createElement('img');
    }

    preload(needPreload) {
        return new Promise(resolve => {
            const loaded = () => {
                this.isPreloaded = true;
                resolve();
            };

            this.imageElement.src = this.testElement.secureURL;

            if (needPreload) {
                this.imageElement.addEventListener('load', (e) => {
                    e.preventDefault();
                    loaded();
                });
            } else {
                loaded();
            }
        });
    }

    start() {
        return new Promise((resolve) => {
            this.imageElement.src = this.testElement.secureURL;
            this.signal = resolve;
            this.stateChanged();
            this.isStarted = true;
            this.isSkipped = false;

            this._display();
        });
    }

    _display() {
        this._show();

        this.position = 0;
        if (this.updatePositionTimeout) {
            clearTimeout(this.updatePositionTimeout);
        }

        const updatePosition = () => {
            return setTimeout(() => {
                this.position += 100;
                if (this.position < this.testElement.cutoffTime) {
                    this.updatePositionTimeout = updatePosition();
                } else {
                    clearTimeout(this.updatePositionTimeout);
                    this.onStop();
                }
            }, 100);
        };

        this.updatePositionTimeout = updatePosition();
        this.stateChanged();
    }

    getPosition() {
        const res = {};
        res.elementId = this.testElement.testElementSequenceID;
        res.position = this.position;
        return res;
    }

    stateChanged() {
        if (this.stateChangedCallback) {
            try {
                this.stateChangedCallback(this.testElement);
            }
            catch (e) { }
        }
    }

    onStateChange(clbck) {
        if (clbck) {
            this.stateChangedCallback = clbck;
        }
    }

    onStop() {
        this.stateChanged(this.testElement);
        if (this.displayTimeout) {
            clearTimeout(this.displayTimeout);
        }

        if (this.updatePositionTimeout) {
            clearTimeout(this.updatePositionTimeout);
        }

        this._hide();
        this.isStarted = false;
        this.signal();
    }

    onLoaded(callback) {
        if (callback && typeof callback === "function" && this.endLoading.indexOf(callback) < 0) {
            this.endLoading.push(callback);
        }
    }

    removeCallbacks() {
        this.startLoading = [];
        this.endLoading = [];
    }

    close() {
        if (this.isStarted) {
            this.onStop();
        }
    }

    _show() {
        const imagePlayerElement = document.getElementById('image-player');
        imagePlayerElement.classList.add('playing');

        const imagePlayerWrapperElement = document.getElementById('image-player-wrapper');
        imagePlayerWrapperElement.innerHTML = '';
        imagePlayerWrapperElement.append(this.imageElement);

        this.testElement.scaleMode = ScaleMode.SCALE;

        switch (this.testElement.scaleMode) {
            case ScaleMode.SCALE:
                imagePlayerElement.classList.add('scale');
                break;
            case ScaleMode.SCROLL:
                if (imagePlayerWrapperElement.height() <= imageElement.height()) {
                    document.documentElement.style.overflow = 'auto';
                }
                break;
        }
    }

    skip() {
        clearTimeout(this.displayTimeout);
        this.isSkipped = true;
        this.onStop();
    }

    _hide() {
        const imagePlayerElement = document.getElementById('image-player');
        imagePlayerElement.classList.remove('playing');

        const imagePlayerWrapperElement = document.getElementById('image-player-wrapper');
        imagePlayerWrapperElement.innerHTML = '';

        switch (this.testElement.scaleMode) {
            case ScaleMode.SCALE:
                imagePlayerElement.classList.remove('scale');
                break;
            case ScaleMode.FIXED:
                break;
            case ScaleMode.SCROLL:
                document.documentElement.style.overflow = 'hidden';
                break;
        }
    }
}